export const GET_FILLED_ORDERS = 'HISTORICAL/GET_FILLED_ORDERS'
export const GET_ORDERS = 'HISTORICAL/GET_ORDERS'
export const GET_FILLED_TRADES = 'HISTORICAL/GET_FILLED_TRADES'
export const GET_TRANSFERS = 'HISTORICAL/GET_TRANSFERS'
export const SET_FILLED_ORDERS = 'HISTORICAL/SET_FILLED_ORDERS'
export const SET_ORDERS = 'HISTORICAL/SET_ORDERS'
export const SET_ORDER_DETAIL = 'HISTORICAL/SET_ORDER_DETAIL'
export const SET_TRANSFERS = 'HISTORICAL/SET_TRANSFERS'
export const SET_CAN_LOAD_MORE = 'HISTORICAL/SET_CAN_LOAD_MORE'
export const SET_IS_LOADING_ORDERS = 'HISTORICAL/SET_IS_LOADING_ORDERS'
export const SET_IS_LOADING_TRADES = 'HISTORICAL/SET_IS_LOADING_TRADES'
export const SET_FILLED_TRADES = 'HISTORICAL/SET_FILLED_TRADES'
export const SET_LOOKBACK = 'HISTORICAL/SET_LOOKBACK'
